import styled from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div`
  ${tw`flex flex-col mb-4 w-full`}
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  ${(props) => props.css}
`;

export const Label = styled.label`
  ${tw`font-medium text-sm leading-5 text-blue-gray-700`}
`;

export const Error = styled.span`
  ${tw`text-red-600 text-xs font-normal mt-1 leading-4 tracking-normal h-16px`}
`;
